{
  "DIGITAL_ASSETS": "Mediaportal",
  "LOGIN_COLMEC_B2B": "Välkommen till Colmec B2B. Logga in med dina användaruppgifter.",
  "COLMEC_CAMPAIGN": "Outlet",
  "EXPRESS_DELIVERY_NOT_AVAILABLE_SPIKES_SIPING_ASSEMBLY": "Expressfrakt ej möjligt vid tillval dubbning, saipning eller montering",
  "NOT_ENOUGH_AVAILABILITY": "Tillgängligt saldo saknas",
  "SELECT_ACTION": "Välj åtgärd",
  "VALIDATION": "Validering",
  "TRY_AGAIN": "Försök igen",
  "RECYCLING_FEES_WILL_BE_ADDED": "Återvinningsavgift tillkommer",
  "ITEMS_ADDED_AS_MANDATORY_EXTRAS_TO_ABOVE_CART": "Nedanstående artiklar har lagts till automatiskt",
  "CART_CONTAINS_AUTO_ADDED_PRODUCTS": "Varukorgen innehåller produkter som lagts till automatiskt",
  "COLMEC_NEW_PRODUCT": "Nyhet",
  "COLMEC_ADD_DUBBING": "Dubbning",
  "USER_AVAILABILITY_OUT_OF_STOCK": "Ej på lager. Kontakta oss på 011 - 13 40 37 för mer information",
  "COLMEC_NO_PRODUCTS_FOUND_CONTACT_US": "Vi kunde inte hitta det du söker<br/>Kontakta oss på 011 - 13 40 37 så hjälper vi dig.",
  "YES_EXPRESS_DELIVERY_INCL_COST_INFO": "Ja",
  "EXPRESS_DELIVERY": "Externt fraktbolag - lämnar Colmec nästkommande vardag.",
  "AR_VARUGRUPPKOD": "Varumärke",
  "NO_BRAND_DEFINED": "Inget märke definerad",
  "NO_PATTERN_DEFINED": "Inget mönster definerad",
  "AR_ITEMTYPECD6": "Användningstyp",
  "NO_USAGE_TYPE_DEFINED": "Ingen användningstyp definerad",
  "AR_Q_MS": "M+S",
  "NO_MS_DEFINED": "Ingen M+S definerad",
  "AR_Q_3PMSF": "3PMSF",
  "NO_3PMSF_DEFINED": "Igen 3PMSF definerad",
  "DIMENSION": "Dimension",
  "NO_DIMENSION_DEFINED": "Ingen dimension definierad",
  "PRODUCT_RELATED_PRODUCTS": "Relaterade produkter",
  "NO_PRODUCT_RELATED_PRODUCTS_FOUND": "Inga relaterade produkter har hittats",
  "PRODUCT_RELATED_ADDONS": "Tillbehör",
  "NO_PRODUCT_RELATED_ADDONS_FOUND": "Inga relaterade tillbehör har hittats",
  "SUBASSORTMENTS": "Sortiment",
  "ITEM_NO": "Artikelnummer",
  "NET_PRICE": "Nettopris",
  "NET_PRICE_INC_FRAME": "Nettopris inkl. stomme",
  "AR_ITEMTYPECD1": "Bredd",
  "AR_ITEMTYPECD2": "Profil",
  "AR_ITEMTYPECD3": "Diameter",
  "AR_ITEMTYPECD4": "Fabrikat",
  "AR_ITEMTYPECD5": "Mönster",
  "AR_Q_POSITION": "Position",
  "AR_Q_MONSTERDJUP": "Mönsterdjup",
  "AR_Q_KLASSID": "Stomklass",
  "NO_STOMKLASS": "Stomklasser saknas",
  "LISTPRIS": "Listpris",
  "PRODUCT_DETAIL_PROPERTIES": "Egenskaper",
  "PRODUCT_DETAIL_ADDONS": "Tillägg",
  "ADDONS": "Tillägg",
  "PRODUCT_DETAIL_DOCUMENTS": "Dokument",
  "SPIKES": "Dubbing ",
  "THANK_YOU_EMAIL_CONFIRMATION_FROM_CONTEXT_ORIGINAL_INPUT": "Tack för din beställning!",
  "SIPING": "Saipning",
  "EU_LABELING": "EU Märkning",
  "GROSS_PRICE": "Listpris",
  "ADDITIONAL_COSTS": "Tilläggskostnader",
  "AR_Q_BULTCIRKEL": "Bultcirkel",
  "AR_Q_NAVHAL": "Navhål",
  "AR_Q_INPRESSNING": "Inpressning",
  "AR_Q_MAXBELASTNING": "Maxbelastning",
  "AR_Q_BULTHAL": "Bulthål",
  "AR_Q_LI": "Load Index",
  "AR_Q_SI": "Speed Index",
  "AR_Q_BRANSLEEFF": "Bränsleeffektivitet",
  "AR_Q_VATGREPP": "Våtgrepp",
  "AR_Q_BULLERVARDE": "Bullervärde",
  "AR_Q_BULLERKLASS": "Bullerklass",
  "EXPRESS_FREIGHT": "Expressfrakt",
  "COLMEC_NO_AUTO_ADDED_PRODUCT": "",
  "COLMEC_CHECKOUT_NO_ADDONS": "Inga tillval möjliga för valda produkter",
  "PRICE_EXCLUSIVE_FRAME": "Pris exklusive stomme",
  "CLASS": "Klass",
  "RETHREADED": "Regummerat",
  "ADDITIONAL_DELIVERY_TIME_SIPING_SPIKES": "Leveranstid för Dubbning / Saipning: 6 dagar",
  "COLMEC_TOOLTIP_AVAILABIITY_MISSING": "Överskrider tillgängligt saldo",
  "DELIVERY_DATE_REQUIRED": "Leveransdatum krävs",
  "PRODUCT_LIST_TOTAL": "Visar {{render}} av {{total}} produkter",
  "COLMEC_DELIVERY_DATE": "Avgår från Colmec",
  "COLMEC_SEARCH_PRODUCTS_PLACEHOLDER": "SÖK: Ex. 315/80 BSG Continental",
  "COLMEC_PLACE_ORDER_TERMS_AND_CONDITIONS": "Genom att skicka order godkänner du våra ",
  "COLMEC_RIM": "Fälg",
  "COLMEC_ASSEMBLY": "Hopsättning",
  "COLMEC_AUTO_ADDED": "Auto tillagd",
  "COLMEC_ADDON": "Tillägg",
  "COLMEC_PLACE_ORDER_TERMS_AND_CONDITIONS_LINK": "Allmänna villkor",
  "ADD_RIM": "Addera fälg",
  "ADD_RIMS": "Lägg till fälg",
  "CLEAR_AND_CLOSE": "Rensa och stäng",
  "ADD_AND_CLOSE": "Lägg till och stäng",
  "SELECT_ASSEMBLY": "Monteringsalternativ",
  "RIM_REQUIRED": "Behöver välja en fälg och montering",
  "COLMEC_LOGIN_CONTACT_US": "Saknar du inloggningsuppgifter?",
  "COLMEC_LOGIN_CONTACT_US_CONTACTS": "Kontakta oss på webshop@colmec.se så hjälper vi dig att komma igång",
  "COLMEC_NO_CAMPAIGNS_FOUND": "Tyvärr har vi inga aktiva kampanjer just nu men håll utkik efter utförsäljningar och kampanjer som publiceras löpande på denna sida.",
  "NOT_INCLUDE_RETURN": "Vi reserverar oss för eventuell utförsäljning. Först till kvarn gäller. Vid köp av outlet- eller kampanjartiklar gäller ej returrätt eller eventuell avtalad bonus.",
  "AR_Q_ALIVE": "Alive",
  "NEW_RETREADED_TIRES_RIMS": "Nya däck, regummerande däck och fälgar",
  "USED_TIRES_ARE_MOST": "Uttjänta däck är en av de mest problematiska typerna av avfall idag på grund av den höga volymen som uppkommer vaje år,",
  "FOR_THEIR_DURABILITY": "och för deras hållbarhet",
  "WELCOME_TO_COLMEC_B2B": "Välkommen till Colmec B2B",
  "LAST_ORDERS": "Senaste beställningar",
  "COLMEC_CIRCLE": "Läs mer om vår nya miljösatsning här",
  "FILTER_SEARCH": "Filtrera din sökning ",
  "MISSING_SOMETHING_SPECIFIC": "Saknar du något specifikt?",
  "GET_IN_TOUCH": "hör av dig till oss så ser vi över",
  "OPORTUNITY_TO_PRODUCE": "möjligheten att ta fram det du söker.",
  "OPEN_HOURS_WEEK": "Öpppettider: Mån-fre",
  "FAQ": "Vanligafragor",
  "SHOW_PRODUCT": "Visa produkt",
  "EXPLORE_THE_RANGE": "UTFORSKA SORTIMENTET",
  "UNIQUE_TOTAL_CONCEPT": "UNIKT TOTALKONCEPT",
  "SAFE_LAZY": "Din trygga och lönsamma",
  "FUNCTIONAL_PARTNER": "funktionspartner.",
  "PRODUCTS_SERVICES_SERVICE_SUPPORT": "Produkter, tjänster, service och support",
  "BEST_QUALITY": "med bästa kvalitet",
  "TRUST_PERFORMANCE_GREENER_CHOICE": "Trust the performance, gör ett grönare val",
  "HIGH_QUALITY_RETREADED_TIRES": "med våra högkvalitativa regummerade däck!",
  "HEADLINE_TRUST_FEEL": "Som rubriken säger, du kan lita på och känna dig trygg med ett regummerat däck tillverkad av oss!",
  "TECHNOLOGY_DEVELOPMENT_QUALITY": "Vi arbetar hela tiden med att ligga i framkant när det kommer till teknik, utveckling och kvalitet.",
  "DISCOVERY_PREMIUM_TIRE": "Uppäck våra regummerade däck",
  "FULL_TITLE_TEXT": "Scenester beard godard knausgaard keffiyeh, vice banjo coloring book. Sartorial butcher aesthetic meditation pickled polaroid YOLO semiotics austin.",
  "SUBTITLE_TEXT": "Cold-pressed glossier echo park subway tile tumblr, freegan distillery bespoke normcore polaroid. Sratorial celiac literally, freegan synth leggings brooklyn slow-carb messenger bag tbh art party meggings. Adaptogen pour-over portland slow-card, deep v skateboard taiyaki taxidermy.",
  "MANAGE_CUSTOMERS": "Hantera kunder",
  "MANAGE_ORDERS": "Hantera ordrar",
  "COLMEC_STARTPAGE": "Colmec Startpage",
  "SALES_QUANTITY_PER_YEAR": "Försäljningskvantitet per år",
  "SALES_QUANTITY_PER_MONTH": "Försäljningskvantitet per månad",
  "SALES_QUANTITY_PER_WEEK": "Försäljningskvantitet per vecka",
  "SELECT_PRODUCT": "Välj produkt",
  "SEE_PRICE_PER": "Se pris per stomme",
  "DISC_BRAKES": "Skivbroms",
  "DRUM_BRAKES": "Trumbroms",
  "Levande": "Alive",
  "END_CUSTOMER": "Slutkund",
  "COLMEC_NO_PRODUCT_CONCEPT": "Inga produkter finns tillgängliga i lager just nu",
  "Q_GUNG_EU": "EU Märkning",
  "LINK": "Länk",
  "CREATE_CLAIM": "Skapa reklamation",
  "CLAIM_CREATED_SUCCESS": "Reklamation med nummer {{id}} har skapats. En bekräftelse har skickats till din e-post.",
  "DETAILS": "DETALJER",
  "CLAIMS": "Reklamationer",
  "ORKK_KUNDREKLAMATIONBESKR": "Typ av reklamation",
  "CLAIMWORKFLOW_CLAIMWORKFLOWDESCR": "Önskad åtgärd",
  "Q_ARTSERIENR": "Serienr.",
  "Q_DOTNR": "Dotnr.",
  "EDIT": "Notering",
  "SALJARE": "Säljare",
  "FTGNR": "Kundnr.",
  "ORDERNR": "Ordernr.",
  "FAKTNR": "Fakturanr.",
  "CLAIMQTY": "Reklamerat antal",
  "FORETAGKOD": "Företagskod",
  "EVENTNOTE": "Utfall",
  "ARTNR": "Artikelnr",
  "EDIT_CUSTOMER": "Redigera kund",
  "UPDATE_CUSTOMER": "Uppdatera kund",
  "CUSTOMER_UPDATE_SUCCESS": "Kunden uppdaterad",
  "CUSTOMER_UPDATE_ERROR": "Fel vid uppdatering av kund.",
  "CUSTOMER_UPDATE_FORM_ERROR": "Uppdatera kundformuläret innehåller fel. Revidera fälten.",
  "NOTE": "Anteckning / Dimension / Mönster",
  "Registered": "Ny",
  "Started": "Påbörjad",
  "Closed": "Avslutad",
  "MARK_AS_REGISTERED": "Markera som Ny",
  "MARK_AS_STARTED": "Markera som Påbörjad",
  "MARK_AS_CLOSED": "Markera som Avslutad",
  "MARK_AS_NY": "Markera som Ny",
  "MARK_AS_PÅBÖRJAD": "Markera som Påbörjad",
  "MARK_AS_AVSLUTAD": "Markera som Avslutad",
  "STATUS": "Statuses",
  "NOTE_ADD_EDIT": "Notes / Anteckningar",
  "SEND_QUOTE": "Skicka offert",
  "KOMPLETT_HJUL": "Komplett hjul",
  "CLAIMACTIVITYSTATUS_CLAIMACTIVITYSTATUSDESCR": "Aktivitetsstatus",
  "QUOTE_TO_ORDER": "Skapa order från offert",
  "CANCEL_QUOTE": "Radera offert",
  "QUOTE": "Offert",
  "PARTNER_AGREEMENT": "Partneravtal",
  "PARTNER_AGREEMENTS": "Partneravtal",
  "PARTNER": "Partner",
  "CREATE_AGREEMENT": "Skapa partneravtal",
  "PARTNER_AGREEMENT_CREATE": "Skapa partneravtal",
  "PARTNER_AGREEMENT_EDIT": "Redigera partneravtal",
  "PARTNER_ID": "Partner-ID",
  "EDIT_PARTNER_AGREEMENT": "Redigera partneravtal",
  "VIEW_AGREEMENT": "Visa avtal",
  "WORK_PERFORMED_DATE": "Datum för utfört arbete",
  "REG_NR": "Reg.nr.",
  "REASON_FOR_WORK": "Skäl till arbete",
  "TIRES": "Däck",
  "ADD_TO_WORKING_ORDER": "Lägg till i arbetsorder",
  "SEARCH_TIRE": "Sök däck utifrån dimension, märke, mönster eller artikelnummer",
  "TIRE_POSITION": "Däckposition",
  "TIRE_ID": "Däck-ID",
  "TIRE_NAME": "Däcknamn",
  "NO_TIRES_SELECTED_ERROR": "Inga däck har lagts till i fungerande skick!",
  "SERVICES": "Tjänster",
  "SEARCH_SERVICE": "Sök efter tjänst",
  "SERVICE_QUANTITY": "Antal",
  "SERVICE_ID": "Tjänst-ID",
  "SERVICE_NAME": "Tjänstens namn",
  "NO_SERVICES_SELECTED_ERROR": "Inga tjänster har lagts till i fungerande skick!",
  "EXTRAS": "Extras",
  "NO_EXTRAS_SELECTED_ERROR": "Inga extra har lagts till i arbetsordningen!",
  "ARTIKEL": "Artikel",
  "SUBMIT_WORKING_ORDER": "Skicka arbetsorder",
  "POSITION": "Position",
  "PREVIEW_AGREEMENT": "Förhandsgranska avtal",
  "DELETE_AGREEMENT": "Ta bort avtal",
  "DELETE_PARTNER_AGREEMENT_CONFIRM": "Är du säker på att du vill ta bort detta partneravtal?",
  "TOTAL_QUANTITY": "Total kvantitet",
  "TOTAL_VALUE": "Totalt värde",
  "SUPPLIER_DELIVERY_NUMBER": "Leverantörs leveransnummer",
  "SUPPLIER_EAN": "Leverantör EAN",
  "PLANNED_SHIFT_WEAR": "Planerat skifte slitage",
  "PLANNED_CHANGE_OF_SEASON": "Planerat säsongsbyte",
  "PUNCTURE_DAMAGE": "Punktering / skada",
  "ON_CALL_ACUTE_INJURY": "Jour / akut skada",
  "MISCELLANEOUS": "Övrigt",
  "PRICE_SEK": "Pris (SEK)",
  "EXIT_WORKING_ORDER_POPUP": "Lämna arbetsorder?",
  "EXIT_WORKING_ORDER_POPUP_DESCRIPTION": "Är du säker på att du vill lämna den nuvarande arbetsordern?",
  "REG_NR_WORKING_ORDER": "Reg.no eller annat fordons-ID",
  "NO_TIRES_AVAILABLE": "Inga däck tillgängliga",
  "STEER_AXLE_OPTION": "Styr",
  "DRIVE_AXLE_OPTION": "Driv",
  "RUN_AXLE_OPTION": "Löp",
  "AXLE": "Axel",
  "ARTICLE_WORKING_ORDER": "Beskrivning av produkt / tjänst",
  "DESCRIPTION_WORKING_ORDER": "Orsak / motivering till produkt utanför avtal",
  "TOTAL_VALUE_WORKING_ORDER": "Totalt värde för arbetsorder",
  "WORKING_ORDER_SUMMARY_INFO": "Klicka på föregående knappen om du behöver gå bakåt och göra ändringar",
  "WORK_SUBMITTED_SUCCESSFULLY": "Arbetsorder har skickats!",
  "WORK_ORDER_GENERIC_ERROR": "Något gick fel, försök igen senare.",
  "TIRE_POLICY_LIST": "Däckpolicylista",
  "IMPORT_TIRE_POLICIES": "Policyer för import av däck",
  "WORK_ORDERS_LIST": "Arbetsorderlista",
  "CREATE_WORK_ORDER": "Skapa arbetsorder",
  "WORK_ORDER_STATE": "Arbetsorderstatus",
  "WORK_ORDER_ID": "Arbetsorder-id",
  "WORK_ORDERS": "Arbetsordrar",
  "APROVE_WORK_ORDER": "Godkänn arbetsorder",
  "DECLINE_WORK_ORDER": "Avvisa arbetsorder",
  "CANCEL_WORK_ORDER": "Avbryt arbetsorder",
  "DELETE_PARTNER_AGREEMENT_SUCCESS": "Partneravtalet har tagits bort",
  "DELETE_PARTNER_AGREEMENT_ERROR": "Fel vid borttagning av partneravtal",
  "ARCHIVE_AGREEMENT": "Arkivera avtal",
  "ARCHIVE_PARTNER_AGREEMENT_CONFIRM": "Är du säker på att du vill arkivera detta partneravtal?",
  "ARCHIVE_PARTNER_AGREEMENT_SUCCESS": "Partneravtalet har arkiverats",
  "ARCHIVE_PARTNER_AGREEMENT_ERROR": "Fel vid arkivering av partneravtal",
  "RESTORE_AGREEMENT": "Återställ avtal",
  "RESTORE_PARTNER_AGREEMENT_CONFIRM": "Är du säker på att du vill återställa detta partneravtal?",
  "RESTORE_PARTNER_AGREEMENT_SUCCESS": "Partneravtalet har återställts",
  "RESTORE_PARTNER_AGREEMENT_ERROR": "Fel vid återställning av partneravtal",
  "WORKING_ORDER_COMMENT": "Kommentar",
  "WORKING_ORDER_DECISION": "Beslut om arbetsorder",
  "EDIT_WORK_ORDER": "Redigera arbetsorder",
  "GROSS_PRICE_WORKING_ORDER": "Bruttopris",
  "CREDIT_BLOCKED_COLMEC": "You will not be able to place an order since your account has been credit blocked at Colmec. Please contact Colmec for more information and to resolve this issue.",
  "AVAILABILITY_EXCEEDED": "Beställd mängd överskrider lagersaldo"
}